import { useState } from "react";
import AppNavDropdown from "./AppNavDropdown";
import AppNavIcon from "./AppNavIcon";
import { ReactComponent as CustomFieldsIcon } from "../../assets/img/nav/custom-fields-outline.svg";
import { ReactComponent as TagsIcon } from "../../assets/img/nav/tags-outline.svg";
import { ReactComponent as SettingsIcon } from "../../assets/img/nav/settings.svg";
import { ReactComponent as EventsIcon } from "../../assets/img/nav/event-management.svg";

/**
 * Dropdown for app navigation
 */
const AppNavManage = () => {
  const [isOpen, setIsOpen] = useState(false);
  // return

  // </span>;
  return (
    <div
      className="sidebar-nav-item cursor-pointer"
      onClick={() => setIsOpen(!isOpen)}
    >
      <span>
        <span className="main-bar-nav-item">
          Manage
          <div className="ml-2 caret" />
        </span>
        <AppNavDropdown
          className="mt-0 main-bar-nav-item-manage"
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          placement={"bottom-start"}
          options={[
            // {
            //   contents: (
            //     <>
            //       <ImportPeopleIcon className="nav-icon" />
            //       Import People
            //     </>
            //   ),
            //   to: "/people/imports",
            // },
            {
              contents: (
                <>
                  <TagsIcon className="nav-icon" />
                  Tags
                </>
              ),
              to: "/settings/tags",
            },
            {
              contents: (
                <>
                  <CustomFieldsIcon className="nav-icon" />
                  Custom Fields
                </>
              ),
              to: "/settings/fields",
            },
            {
              contents: (
                <>
                  <SettingsIcon className="nav-icon" stroke="#444d63" />
                  Settings
                </>
              ),
              to: "/settings/apps",
            },
            {
              contents: (
                <>
                  <EventsIcon className="nav-icon" stroke="#444d63" />
                  Events
                </>
              ),
              to: "/events",
            },
          ]}
        />
      </span>
    </div>
  );
};
export default AppNavManage;
